import React from 'react';

const Assign = ({ svgRef, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" ref={svgRef} {...props}><g><g><g><path fill="#49c6be" d="M0 15C0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15z"/></g><g><g><path fill="#fff" d="M21.998 13.667h-1.667V12a.333.333 0 0 0-.333-.333h-.667a.333.333 0 0 0-.333.333v1.667h-1.667a.333.333 0 0 0-.333.333v.667c0 .184.15.333.333.333h1.667v1.667c0 .184.15.333.333.333h.667c.184 0 .333-.15.333-.333V15h1.667c.184 0 .333-.15.333-.333V14a.333.333 0 0 0-.333-.333zm-9 1.333a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333zm4.3 2.44a2 2 0 0 0-1.793-1.107H10.49a2 2 0 0 0-1.793 1.107l-.96 1.927a.667.667 0 0 0 .593.966h9.334a.667.667 0 0 0 .593-.966z"/></g></g></g></g></svg>
);

export default Assign



// WEBPACK FOOTER //
// ./src/common/icons/Assign.js